module.exports = __webpack_public_path__ + "img/homepage-content-image-chevy.6e4bc5b4.jpg";